"use client";

import { Check, Copy } from "lucide-react";

interface CopyLinkButtonProps {
  onCopy: () => void;
  copied: boolean;
  title?: string;
}

/**
 * Shared copy link button component
 * Used in post cards on thread pages and My Posts page
 */
export function CopyLinkButton({ onCopy, copied, title }: CopyLinkButtonProps) {
  return (
    <button
      onClick={onCopy}
      className={`flex h-8 w-8 items-center justify-center rounded-full border transition ${
        copied
          ? "border-green-500/50 bg-green-500/10"
          : "border-[#262636] bg-[#0a0a12] hover:border-[rgba(255,255,255,0.16)] hover:bg-[#141422]"
      }`}
      title={title || (copied ? "Link copied!" : "Copy link")}
    >
      {copied ? (
        <Check className="h-4 w-4 text-green-400" />
      ) : (
        <Copy className="h-4 w-4 text-[#a3a3c2]" />
      )}
    </button>
  );
}
